module.exports = __webpack_public_path__ + "img/abab21f.jpg";